<mat-card class="alert-card" [ngClass]="alertClass">
  <mat-card-content>
    <div class="alert-header">
      <mat-icon class="alert-icon">{{ alertIcon }}</mat-icon>

      <div class="alert-header-text">
        <p class="alert-title">{{ communication.title }}</p>
        <p class="alert-message">{{ communication.message }}</p>
      </div>

    </div>

    <!-- Warning: outstanding invoices -->
    @if (communication.priority === 'Warning') {
      <div class="alert-actions">
        <button mat-stroked-button class="action-secondary" (click)="onViewInvoices()">
          <mat-icon>receipt_long</mat-icon>
          View Invoices
        </button>
      </div>
    }

    <!-- Critical: lapsed / urgent -->
    @if (communication.priority === 'Critical') {
      <div class="alert-actions">
        <button mat-raised-button class="action-primary" (click)="onViewInvoices()">
          <mat-icon>receipt_long</mat-icon>
          Review Invoices
        </button>
      </div>
    }
  </mat-card-content>
</mat-card>
